import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { BookingCartProvider } from './contexts/BookingCartContext';
import { VenuesListScreen } from './pages/VenuesListScreen';
import { VenuesMapScreen } from './pages/VenuesMapScreen';
import { VenueDetailScreen } from './pages/VenueDetailScreen';
import { CalendarScreen } from './pages/CalendarScreen';
import { CourtDetailScreen } from './pages/CourtDetailScreen';
import { BookingCartScreen } from './pages/BookingCartScreen';
import { BookingProcessingScreen } from './pages/BookingProcessingScreen';
import { BookingConfirmationScreen } from './pages/BookingConfirmationScreen';
import { BookingsScreen } from './pages/BookingsScreen';
import { BookingsPopulatedScreen } from './pages/BookingsPopulatedScreen';
import { ProfileScreen } from './pages/ProfileScreen';
import { ProfileLoggedOutScreen } from './pages/ProfileLoggedOutScreen';
import { LoginScreen } from './pages/LoginScreen';
import { NotificationsScreen } from './pages/NotificationsScreen';
import { PromotionScreen } from './pages/PromotionScreen';
import { DirectionsScreen } from './pages/DirectionsScreen';
import { SplashScreen } from './pages/SplashScreen';
export function App() {
  return <BrowserRouter data-id="element-0">
      <BookingCartProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Navigate to="/splash" replace data-id="element-4" />} data-id="element-3" />
          <Route path="/splash" element={<SplashScreen data-id="element-6" />} data-id="element-5" />
          <Route path="/home" element={<VenuesListScreen data-id="element-8" />} data-id="element-7" />
          <Route path="/map" element={<VenuesMapScreen data-id="element-10" />} data-id="element-9" />
          <Route path="/venue/:venueId" element={<VenueDetailScreen data-id="element-12" />} data-id="element-11" />
          <Route path="/venue/:venueId/calendar" element={<CalendarScreen data-id="element-14" />} data-id="element-13" />
          <Route path="/court/:id" element={<CourtDetailScreen data-id="element-16" />} data-id="element-15" />
          <Route path="/calendar" element={<CalendarScreen data-id="element-18" />} data-id="element-17" />
          <Route path="/booking/cart" element={<BookingCartScreen data-id="element-20" />} data-id="element-19" />
          <Route path="/booking/processing" element={<BookingProcessingScreen data-id="element-22" />} data-id="element-21" />
          <Route path="/booking/confirmation/:id" element={<BookingConfirmationScreen data-id="element-24" />} data-id="element-23" />
          <Route path="/bookings" element={<BookingsScreen data-id="element-26" />} data-id="element-25" />
          <Route path="/bookings/populated" element={<BookingsPopulatedScreen data-id="element-28" />} data-id="element-27" />
          <Route path="/bookings/confirmation/:id" element={<BookingConfirmationScreen data-id="element-30" />} data-id="element-29" />
          <Route path="/profile" element={<ProfileScreen data-id="element-32" />} data-id="element-31" />
          <Route path="/profile/logged-out" element={<ProfileLoggedOutScreen data-id="element-34" />} data-id="element-33" />
          <Route path="/login" element={<LoginScreen data-id="element-36" />} data-id="element-35" />
          <Route path="/notifications" element={<NotificationsScreen data-id="element-38" />} data-id="element-37" />
          <Route path="/promotion" element={<PromotionScreen data-id="element-40" />} data-id="element-39" />
          <Route path="/directions" element={<DirectionsScreen data-id="element-42" />} data-id="element-41" />
        </Routes>
      </BookingCartProvider>
    </BrowserRouter>;
}